import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioMaterial from '../servicios/ServicioMaterial';
import servicioRetenciones from '../servicios/ServicioRetenciones';
import servicioAtributo from '../servicios/ServicioAtributo';
export class Materiales extends Component {
    constructor() {
        super();
        this.state = {
            material: {},
            paginacion: {
                registrosPorPagina: 20
            },
            inicio: 0,
            erroresRequeridos: {},
            mostrarModalMateriales: false,
            mostrarModalConfirmacion: false,
            mostrarModalAtributo: false,
            mostrarModalEliminarAtributo: false,
            estados_iva: [
                { name: '0.160000', code: '0.160000' },
                { name: '0.080000', code: '0.080000' },
                { name: '0.000000', code: '0.000000' },
                { name: 'Exento', code: 'Exento' }
            ],
            atributos: [],
            atributo: {},
            tcRetencionesMateriales: [],
            retencion: {},
            retencionesBase: [],
            objetosImpuesto: [
                { name: 'No objeto de impuesto.', code: '01' },
                { name: 'Sí objeto de impuesto.', code: '02' },
                { name: 'Sí objeto del impuesto y no obligado al desglose.', code: '03' },
                { name: 'Sí objeto del impuesto y no causa impuesto.', code: '04' },
                { name: 'Sí objeto del impuesto, IVA crédito PODEBI.', code: '05' }
            ]

        }
    }
    componentDidMount() {
        this.obtenerPagina();

    }
    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioMaterial.paginacion(paginacion).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });


        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

    }
    buscar_like = () => {
        let { material, paginacion } = this.state;
        servicioMaterial.busqueda_like(material).then(response => {
            if (response.data.lista.length === 0) {
                this.growl.show({ life: 1000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            } else {
                this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            }
        })
    }
    validarFormulario = (material) => {
        const errores = {};
        if (!material.claveProducServ)
            errores.claveProducServ = "El campo es requerido";
        if (!material.descripcion)
            errores.material = "El campo es requerido";
        if (!material.claveUnidad)
            errores.claveUnidad = "El campo es requerido";
        if (!material.unidadMedida)
            errores.unidadMedida = "El campo es requerido";
        // if (material.descuento > 100 || material.descuento < 1)
        //     errores.descuento = "Ingresa valor de 1 - 100";
        if (material.ivaRetenido >= 0.0 || material.ivaRetenido <= 0.160000)
            errores.ivaRetenido = "Ingresa valor de 0.0 - 0.1600000";
        return errores;
    }
    guardarAtributo = () => {
        let { atributo, atributos } = this.state;
        const validacion = this.validarFormularioAtributo(atributo);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            atributos.push(atributo);

            this.setState({ atributo: {} });
            this.setState({ mostrarModalAtributo: false, atributo: {} });
        }
    }

    guardar = () => {
        let { material, atributos, retencion } = this.state;
        const validacion = this.validarFormulario(material);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            var materialEnvio = JSON.parse(JSON.stringify(material));
            if (material.ivaGeneral !== undefined) {
                let estado = materialEnvio.ivaGeneral.code;
                delete materialEnvio['ivaGeneral'];
                materialEnvio.ivaGeneral = estado;
            }

            if(material.objetoImp !== undefined){
                let objI=material.objetoImp.code;
                delete materialEnvio['objetoImp'];
                materialEnvio.objetoImp = objI;
            }
            var wrapperMaterial = {};
            wrapperMaterial.tcMateriales = materialEnvio;
            wrapperMaterial.tcAtributoMaterial = atributos;
            if (!retencion.ivaRetenido != null)
                wrapperMaterial.ivaRetenido = retencion.ivaRetenido;
            if (!retencion.isrRetenido != null)
                wrapperMaterial.isrRetenido = retencion.isrRetenido;

            servicioMaterial.guardar(wrapperMaterial).then((response) => {
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                    this.setState({ material: {}, mostrarModalMateriales: false, atributo: {}, atributos: [], retencion: {} });
                this.obtenerPagina();

            }).catch((error) => {
                if (error)
                    return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }

    }
    eliminar = () => {
        let { material } = this.state;
        servicioMaterial.eliminar(material).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false)
                this.setState({ mostrarModalConfirmacion: false });
            this.obtenerPagina();

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }
    eliminarAtributoMaterial = () => {
        let { atributo, atributos } = this.state;

        servicioAtributo.eliminar(atributo).then((response) => {
        }).catch((error) => {
        });

        atributos.splice(atributos.indexOf(atributo), 1);
        this.setState({ atributo: {}, mostrarModalEliminarAtributo: false });

    }
    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);

    }

    editarMaterial = (rowData, column) => {

        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit" className="p-button-success" name="editar"
                    tooltip="editar" onClick={(e) => this.editar(column.rowData)} >
                </Button>
            </div>
        </div>;
    }
    eliminarMaterial = (rowData, column) => {

        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
                    tooltip="eliminar" onClick={(e) => this.mostrarModalEliminar(column.rowData)} >
                </Button>
            </div>
        </div>;
    }
    eliminarAtributo = (rowData, column) => {

        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
                    tooltip="eliminar" onClick={(e) => this.mostrarModalEliminarAtributo(column.rowData)} >
                </Button>
            </div>
        </div>;
    }
    editar(objeto) {
        this.setState({ material: {}, atributos: [], atributo: {}, retencionesBase: [] });
        let { retencionesBase, retencion } = this.state;
        let { estados_iva, objetosImpuesto } = this.state;
        let estado_iva = estados_iva.filter(obj => {
            return obj.code === objeto.ivaGeneral;
        });
        var materialEditar = JSON.parse(JSON.stringify(objeto));
        let estado = estado_iva[0];
        delete materialEditar['ivaGeneral'];
        materialEditar.ivaGeneral = estado;

        let objetoImp=objetosImpuesto.filter(elemento => {
            return elemento.code === objeto.objetoImp;
        });
        materialEditar.objetoImp=objetoImp[0];

        servicioRetenciones.buscarLista(objeto).then((response) => {


            if (response.data.error === false) {
                retencionesBase = response.data.lista;
                this.setState({ retencionesBase: response.data.lista });
                for (var i = 0; i < retencionesBase.length; i++) {
                    if (retencionesBase[i].impuesto === "isr") {
                        retencion.isrRetenido = retencionesBase[i].tasa;
                    }
                    if (retencionesBase[i].impuesto === "iva") {
                        retencion.ivaRetenido = retencionesBase[i].tasa;
                    }
                }
            }
            // this.setState({ mostrarModalMateriales: true, material: objeto });
        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });


        servicioAtributo.buscarAtributos(objeto).then((response) => {
            if (response.data.error === false) {
                this.setState({ mostrarModalMateriales: true, material: materialEditar, atributos: response.data.lista });
            }
        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

    }
    nuevo() {
        this.setState({ mostrarModalMateriales: true, mostrarModalConfirmacion: false, material: {}, atributos: [], atributo: {}, retencion: {}, retencionesBase: [] });
    }
    nuevoAtributo() {
        this.setState({ mostrarModalAtributo: true, atributo: {} });
    }
    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalConfirmacion: true, material: objeto });
    }
    mostrarModalEliminarAtributo = (objeto) => {
        this.setState({ mostrarModalEliminarAtributo: true, atributo: objeto });
    }
    validarFormularioAtributo = (atributo) => {
        const errores = {};
        if (!atributo.nombre)
            errores.nombre = "El nombre es requerido";

        return errores;
    }

    templateObjImp = (option) => {        
        return <div>
            <strong>{option.code}</strong> - <div>{option.name}</div>
        </div>;
    }
    render() {
        const { material, paginacion, inicio, erroresRequeridos, 
            estados_iva, atributo, atributos, retencion,objetosImpuesto } = this.state;
        const dialogFooter = (
            <div>
                <Button icon="pi-md-check" onClick={this.guardar} label="Guardar" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ material: {}, mostrarModalMateriales: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterConfirmacionEliminarMaterial = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ material: {}, mostrarModalConfirmacion: false, erroresRequeridos: {} })} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterConfirmacionEliminarAtributo = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminarAtributoMaterial} label="Si estoy seguro" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ atributo: {}, mostrarModalEliminarAtributo: false, erroresRequeridos: {} })} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterAtributo = (
            <div>
                <Button icon="pi-md-check" onClick={this.guardarAtributo} label="Guardar" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ atributo: {}, mostrarModalAtributo: false, erroresRequeridos: {} })} label="cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        return (<div className="card card-w-title">
            <Growl ref={(el) => this.growl = el} />
            <h1 style={{ marginBottom: '30px' }}>Materiales</h1>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    <Button type="button" className="blue-grey-btn flat-btn" label="Nuevo Material" name="nuevo" value="Nuevo"
                        tooltip="nuevo" onClick={(e) => this.nuevo()} >
                    </Button>
                </div>
                <div className="p-col-12" style={{ marginTop: '30px', fontWeight: 'bold', marginLeft: '5px' }}>
                    <label htmlFor="buscar">Buscar Material:</label>
                </div>
                <div className="p-col-12 p-md-6" style={{ marginLeft: '5px', marginBottom: '30px' }}>
                    <InputText className="p-inputtext" size={100} placeholder="Buscar por Descripción " name="material.descripcion" value={material.descripcion || ''} onChange={this.asignarValoresObjeto} onKeyUp={this.buscar_like} />
                </div>
            </div>
            <Card style={{ marginBottom: '50px' }}>
                <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >
                    <Column field="descripcion" header="Descripcion" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                    <Column field="unidadMedida" header="Unidad de Medida" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                    <Column field="ivaGeneral" header="Iva Traslado" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                    <Column field="cuentaPredial" header="Cuenta Predial" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                    <Column field="noIdentificacion" header="No. Identificación" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                    <Column header="Editar" body={this.editarMaterial.bind(this)} style={{ width: '100px', textAlign: 'center' }} />
                    <Column header="Eliminar" body={this.eliminarMaterial.bind(this)} style={{ width: '100px', textAlign: 'center' }} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
            </Card>
            <Dialog header="Material, los campos con * son requeridos." blockScroll visible={this.state.mostrarModalMateriales}
             modal={true} footer={dialogFooter} style={{ width: '60vw' }} 
             onHide={() => this.setState({ material: {}, mostrarModalMateriales: false, erroresRequeridos: {} })}
             appendTo={document.body}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="claveProducServ">Clave producto servicio: *:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="claveProducServ" name="material.claveProducServ" value={material.claveProducServ || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.claveProducServ ? 'p-error' : ''} />
                        {erroresRequeridos.claveProducServ ? <div> <Message severity="error" text={erroresRequeridos.claveProducServ} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="descripcion">Material*:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="descripcion" name="material.descripcion" value={material.descripcion || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.material ? 'p-error' : ''} />
                        {erroresRequeridos.material ? <div> <Message severity="error" text={erroresRequeridos.material} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="claveUnidad">Clave Unidad* :</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="claveUnidad" name="material.claveUnidad" value={material.claveUnidad || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.claveUnidad ? 'p-error' : ''} />
                        {erroresRequeridos.claveUnidad ? <div> <Message severity="error" text={erroresRequeridos.claveUnidad} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="unidadMedida">Medida *:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="unidadMedida" name="material.unidadMedida" value={material.unidadMedida || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.unidadMedida ? 'p-error' : ''} />
                        {erroresRequeridos.unidadMedida ? <div> <Message severity="error" text={erroresRequeridos.unidadMedida} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="noIdentificacion">No. Identificacion:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="noIdentificacion" name="material.noIdentificacion" value={material.noIdentificacion || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.noIdentificacion ? 'p-error' : ''} />
                        {erroresRequeridos.noIdentificacion ? <div> <Message severity="error" text={erroresRequeridos.noIdentificacion} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="cuentaPredial">Cuenta Predial:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="cuentaPredial" name="material.cuentaPredial" value={material.cuentaPredial || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.cuentaPredial ? 'p-error' : ''} />
                        {erroresRequeridos.cuentaPredial ? <div> <Message severity="error" text={erroresRequeridos.cuentaPredial} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="descuento">Descuento %:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="descuento" name="material.descuento" value={material.descuento || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.descuento ? 'p-error' : ''} />
                        {erroresRequeridos.descuento ? <div> <Message severity="error" text={erroresRequeridos.descuento} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="ivaGeneral">IVA Trasladado:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown id="ivaGeneral" name="material.ivaGeneral" options={estados_iva} value={material.ivaGeneral} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresRequeridos.ivaGeneral ? 'p-error' : ''} />
                        {erroresRequeridos.ivaGeneral ? <div> <Message severity="error" text={erroresRequeridos.ivaGeneral} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="ivaRetenido">IVA Retenido:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="ivaRetenido" name="retencion.ivaRetenido" value={retencion.ivaRetenido || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.ivaRetenido ? 'p-error' : ''} />
                        {erroresRequeridos.ivaRetenido ? <div> <Message severity="error" text={erroresRequeridos.ivaRetenido} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="isrRetenido">ISR Retenido:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="isrRetenido" name="retencion.isrRetenido" value={retencion.isrRetenido || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.isrRetenido ? 'p-error' : ''} />
                        {erroresRequeridos.isrRetenido ? <div> <Message severity="error" text={erroresRequeridos.isrRetenido} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="isrRetenido">Obj Imp *:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown appendTo={document.body} id="objetoImp" name="material.objetoImp"
                         options={objetosImpuesto} value={material.objetoImp}
                         onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" 
                         className={erroresRequeridos.objetoImp ? 'p-error' : ''} itemTemplate={this.templateObjImp}/>
                        {erroresRequeridos.objetoImp ? <div> <Message severity="error" text={erroresRequeridos.objetoImp} /> </div> : null}
                    </div>                    
                    <div className="p-col-12 p-md-4">
                        <Button type="button" className="p-button-success" label="Nuevo Atributo" name="nuevo" value="Nuevo"
                            tooltip="nuevo" onClick={(e) => this.nuevoAtributo()} >
                        </Button>
                    </div>
                    <Card>
                        <DataTable value={atributos} editable={true} scrollable={true} scrollHeight="280px"  >
                            <Column field="nombre" header="Nombre" style={{ width: '200px' }} filter={false} autoLayout={true} />
                            <Column header="Eliminar" body={this.eliminarAtributo.bind(this)} style={{ width: '100px' }} />
                        </DataTable>
                    </Card>
                </div>
            </Dialog>
            <Dialog header="Confirmación" visible={this.state.mostrarModalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminarMaterial} onHide={() => this.setState({ material: {}, mostrarModalConfirmacion: false, erroresRequeridos: {} })}>
                <h2>¿Estás seguro de eliminar el material?</h2>
            </Dialog>
            <Dialog header="Confirmación" visible={this.state.mostrarModalEliminarAtributo} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminarAtributo} onHide={() => this.setState({ atributo: {}, mostrarModalEliminarAtributo: false, erroresRequeridos: {} })}>
                <h2>¿Estás seguro de eliminar el atributo?</h2>
            </Dialog>
            <Dialog header="Nuevo atributo" visible={this.state.mostrarModalAtributo} modal={true} style={{ width: '30vw' }} footer={dialogFooterAtributo} onHide={() => this.setState({ atributo: {}, mostrarModalAtributo: false, erroresRequeridos: {} })}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="nombre">Nombre: *:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="nombre" name="atributo.nombre" value={atributo.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
                        {erroresRequeridos.nombre ? <div> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
                    </div>
                </div>
            </Dialog>
        </div>);
    }
}